var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "DnbarcodeHandmade-TabelHeader" },
    [
      _c(
        "el-form",
        {
          ref: "formData",
          staticClass: "formData",
          attrs: {
            rules: _vm.Rules,
            inline: true,
            model: _vm.formData,
            "label-width": "110px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "送货单号(选填)" } },
            [
              !_vm.isDisabled
                ? _c("el-input", {
                    attrs: { placeholder: "" },
                    model: {
                      value: _vm.formData.DELIVERY_NO,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "DELIVERY_NO", $$v)
                      },
                      expression: "formData.DELIVERY_NO"
                    }
                  })
                : _c("span", { staticClass: "showItemName" }, [
                    _vm._v(_vm._s(_vm.formData.DELIVERY_NO))
                  ])
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "供应商", prop: "VENDOR_CODE" } },
            [
              !_vm.userInfo.VENDOR_CODE
                ? [
                    !_vm.isDisabled
                      ? _c(
                          "el-select",
                          {
                            staticStyle: { "margin-right": "0px" },
                            attrs: {
                              placeholder: "请输入代码或名称",
                              filterable: "",
                              remote: "",
                              "remote-method": _vm.handleInputVendorSelect,
                              loading: _vm.selectLoading,
                              clearable: ""
                            },
                            on: { change: _vm.handleChange },
                            model: {
                              value: _vm.formData.VENDOR_CODE,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "VENDOR_CODE", $$v)
                              },
                              expression: "formData.VENDOR_CODE"
                            }
                          },
                          _vm._l(_vm.vendorOptions, function(item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value }
                            })
                          }),
                          1
                        )
                      : _c("span", { staticClass: "content" }, [
                          _vm._v(_vm._s(_vm.formData.VENDOR_NAME))
                        ]),
                    !_vm.isDisabled
                      ? _c(
                          "span",
                          {
                            staticClass: "changeVendorBtn",
                            on: { click: _vm.handleChangeVendorBtn }
                          },
                          [_vm._v("...")]
                        )
                      : _vm._e()
                  ]
                : [
                    _c("el-input", {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.formData.VENDOR_NAME,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "VENDOR_NAME", $$v)
                        },
                        expression: "formData.VENDOR_NAME"
                      }
                    })
                  ]
            ],
            2
          ),
          _c(
            "el-form-item",
            { attrs: { label: "创建日期", prop: "ARRIVAL_DATE" } },
            [
              !_vm.isDisabled
                ? _c("span", [_vm._v(_vm._s(_vm.formData.CREATE_DATE))])
                : _c("span", { staticClass: "content" }, [
                    _vm._v(_vm._s(_vm.formData.CREATE_DATE))
                  ])
            ]
          ),
          _c("el-form-item", { attrs: { label: "制单人" } }, [
            _c("span", { staticClass: "showItemName" }, [
              _vm._v(_vm._s(_vm.formData.CREATORID))
            ])
          ]),
          _c(
            "el-form-item",
            { staticClass: "remark", attrs: { label: "备注" } },
            [
              !_vm.isDisabled
                ? _c("el-input", {
                    attrs: { disabled: _vm.isDisabled },
                    model: {
                      value: _vm.formData.DESCRIPTION,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "DESCRIPTION", $$v)
                      },
                      expression: "formData.DESCRIPTION"
                    }
                  })
                : _c("span", { staticClass: "showItemName" }, [
                    _vm._v(_vm._s(_vm.formData.DESCRIPTION))
                  ])
            ],
            1
          )
        ],
        1
      ),
      _c("changeVendorDialog", {
        ref: "changeVendorDialog",
        attrs: { isShowChangeVendorDialog: _vm.isShowChangeVendorDialog },
        on: {
          cbDialogSubmit: _vm.cbDialogSubmit,
          closeChangeVendorDialog: _vm.closeChangeVendorDialog
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }